import { CorporationType, Country, LegacyDocumentType } from '@commenda/prisma';
import { BusinessEntityDocumentCategory } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils/logical-backend-fetcher';
import useSWR, { KeyedMutator } from 'swr';

export interface IDocumentRule {
  documentType: BusinessEntityDocumentCategory;
  documentSubType: LegacyDocumentType;
  supportsDataStorage: boolean;
  data: any;
  country: Country;
  jurisdiction: string | null;
  corporationType: CorporationType | null;
  isTimeSensitive: boolean;
  isUnique: boolean;
  documentName: string;
}

export function useSupportedDocuments({
  businessEntityId,
}: {
  businessEntityId: number;
}) {
  let url = `business-entities/${businessEntityId}/documents/supported`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: { supportedDocumentTypes: IDocumentRule[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
